import { jsx as s } from "react/jsx-runtime";
import { withManagedProps as m } from "@made-people/managed-props";
import { z as e } from "zod";
import { withZod as l } from "@made-people/react-prop-guard";
import g, { createElement as d } from "react";
import { partnerLogosTemplate1Blueprint as h } from "./index-blueprint.es.js";
import { responsiveImageSchema as i, ResponsiveImage as P } from "@made-people/blueprint-responsive-image";
import y from "clsx";
import "@made-people/blueprint";
const p = e.object({
  variants: e.custom().optional(),
  blueprint: e.custom().optional(),
  logos: e.union([
    e.array(e.custom()),
    e.array(i)
  ]).optional(),
  className: e.string().optional()
}), L = m(
  "PartnerLogosTemplate1",
  l(
    {
      schema: p,
      defaultProps: {}
    },
    ({ variants: r, logos: o, className: c, blueprint: u }) => {
      const a = (u ?? h).styles(r);
      if (!o || o.length === 0)
        return null;
      function f(t) {
        return i.safeParse(t).success;
      }
      return /* @__PURE__ */ s("section", { className: y(a.wrapper, c), children: o.map((t, n) => g.isValidElement(t) ? /* @__PURE__ */ s("div", { className: a.logo, children: t }, `logo-${n}`) : f(t) ? /* @__PURE__ */ d(
        P,
        {
          ...t,
          className: a.logo,
          key: `logo-${n}`,
          displaySize: "100px"
        }
      ) : null) });
    }
  )
), v = e.discriminatedUnion("template", [
  e.object({ template: e.literal("template1").optional() }).merge(p)
]), E = m(
  "PartnerLogos",
  l(
    { schema: v, defaultProps: { template: "template1" } },
    (r) => r.template === "template1" ? /* @__PURE__ */ s(L, { ...r }) : null
  )
);
export {
  E as PartnerLogos,
  L as PartnerLogosTemplate1,
  v as partnerLogosSchema,
  p as partnerLogosTemplate1Schema
};
//# sourceMappingURL=index.es.js.map
